import React from "react";
import { Box, Typography } from "@mui/material";
import THEME from "../../constants/theme";
import useCommon from "../../hooks/useCommon";
export default function Footer({ compView = false }) {
  const { viewFooter } = useCommon();
  if (!viewFooter && !compView) return null;
  return <Box component="footer" sx={{ mt: "auto", px: { xs: 2, md: 4 }, py: 2.5, borderTop: "1px solid", borderColor: "divider", display: "flex", flexWrap: "wrap", justifyContent: "space-between", gap: 1, bgcolor: "background.paper" }}>
    <Typography variant="caption" color="text.secondary">{new Date().getFullYear()} {THEME.manifest.name}. All rights reserved.</Typography>
    <Typography variant="caption" color="text.secondary">Learn. Grow. Achieve.</Typography>
  </Box>;
}
